module.exports = "<div class=\"container-grid\" appHeight=\"100%\" >\r\n  <ag-grid-angular\r\n    #agGridDriver\r\n    [gridOptions]=\"gridTrips\"\r\n    [enableColResize]=\"true\"\r\n    [enableSorting]=\"true\"\r\n    [enableFilter]=\"true\"\r\n    rowSelection=\"multiple\"\r\n    [rowDragManaged]=\"true\"\r\n    (rowDragEnd)=\"onDragEnd($event)\"\r\n    (gridReady)=\"onGridReady($event)\"\r\n    (cellClicked)=\"onSelectedZipCode($event)\">\r\n  </ag-grid-angular>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/auto-routing-results/components/auto-routing-by-driver/auto-routing-by-driver.component.html
// module id = 2370
// module chunks = 66